import moment from "moment-timezone";
import "moment/locale/es";

moment.locale("es");

const DEFAULT_ICON = "mdi-gift-outline";

const isObject = (value) => value && typeof value === "object" && !Array.isArray(value);

const unwrap = (item) => {
  if (!isObject(item)) return null;
  if (isObject(item.benefit)) return item.benefit;
  return item;
};

export const getBenefitId = (item) => {
  const b = unwrap(item);
  if (!b) return null;
  return b._id || b.id || null;
};

export const getBenefitName = (item) => {
  const b = unwrap(item);
  if (!b) return "Beneficio";
  return b.name || b.title || "Beneficio";
};

export const getBenefitDescription = (item) => {
  const b = unwrap(item);
  if (!b) return "";
  return b.description || b.summary || b.shortDescription || "";
};

export const getBenefitIcon = (item) => {
  const b = unwrap(item);
  if (!b) return null;
  return b.icon || b.image || b.logo || b.picture || null;
};

export const getBenefitUrl = (item) => {
  const b = unwrap(item);
  if (!b) return null;
  return b.url || b.link || b.redirectUrl || null;
};

export const getBenefitType = (item) => {
  const b = unwrap(item);
  if (!b) return "direct";
  return b.benefitType || b.type || "direct";
};

export const getBenefitExpirationDate = (item) => {
  const b = unwrap(item);
  if (!b) return null;
  return b.expiredDate || b.expirationDate || b.expiresAt || null;
};

export const isApiBenefit = (item) => getBenefitType(item) === "api";

export const isExpiredBenefit = (item, now = moment()) => {
  const date = getBenefitExpirationDate(item);
  if (!date) return false;
  const m = moment(date);
  if (!m.isValid()) return false;
  return m.isBefore(now);
};

export const formatBenefitExpiration = (item) => {
  const date = getBenefitExpirationDate(item);
  if (!date) return null;
  const m = moment(date);
  if (!m.isValid()) return null;
  return m.format("DD [de] MMMM [de] YYYY");
};

export const resolveBenefitInitials = (item) => {
  const name = getBenefitName(item);
  if (!name || typeof name !== "string") return "?";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};

export const resolveBenefitIcon = (item) => {
  const icon = getBenefitIcon(item);
  if (!icon) return null;
  if (typeof icon !== "string") return null;
  if (icon.startsWith("mdi-")) return icon;
  return null;
};

export const isValidImageUrl = (value) => {
  if (!value || typeof value !== "string") return false;
  return (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("data:image") ||
    value.startsWith("/")
  );
};

export const sortBenefitsByName = (benefits) => {
  const list = [...(benefits || [])];
  list.sort((a, b) => {
    const na = (getBenefitName(a) || "").toLowerCase();
    const nb = (getBenefitName(b) || "").toLowerCase();
    return na.localeCompare(nb, "es");
  });
  return list;
};

export const applyBenefitSearch = (benefits, search) => {
  if (!Array.isArray(benefits)) return [];
  const term = (search || "").trim().toLowerCase();
  if (!term) return benefits;
  return benefits.filter((item) => {
    const b = unwrap(item);
    if (!b) return false;
    const name = (b.name || "").toLowerCase();
    const desc = (b.description || "").toLowerCase();
    return name.includes(term) || desc.includes(term);
  });
};

export const DEFAULT_BENEFIT_ICON = DEFAULT_ICON;
